export default __webpack_public_path__ + "static/media/934.1f793739.gif";